import { CalendarDays, Disc3, PackageOpen, Ticket } from 'lucide-vue-next'

import type { Component } from 'vue'
import type { ContestMechanic } from '@/types/global'

export type MechanicVisualId = ContestMechanic | 'adventCalendar'

export type MechanicVisual = {
  icon: Component
  panelClass: string
  chipClass: string
  iconClass: string
}

export const mechanicVisuals: Record<MechanicVisualId, MechanicVisual> = {
  fortuneWheel: {
    icon: Disc3,
    panelClass: 'bg-gradient-to-br from-violet-50 to-violet-100',
    chipClass: 'bg-violet-50',
    iconClass: 'text-violet-600'
  },
  scratchCard: {
    icon: Ticket,
    panelClass: 'bg-gradient-to-br from-amber-50 to-amber-100',
    chipClass: 'bg-amber-50',
    iconClass: 'text-amber-600'
  },
  mysteryBox: {
    icon: PackageOpen,
    panelClass: 'bg-gradient-to-br from-sky-50 to-sky-100',
    chipClass: 'bg-sky-50',
    iconClass: 'text-sky-700'
  },
  adventCalendar: {
    icon: CalendarDays,
    panelClass: 'bg-muted',
    chipClass: 'bg-muted',
    iconClass: 'text-foreground-secondary'
  }
}
